export default {
  // Navigation
  nav_home: 'Startseite',
  nav_dashboard: 'Dashboard',
  nav_orders: 'Bestellungen',
  nav_wallet: 'Geldbörse',
  nav_analytics: 'Analytik',
  nav_referral: 'Empfehlung',
  nav_account: 'Konto',
  nav_notifications: 'Benachrichtigungen',
  nav_support: 'Support',
  nav_logout: 'Abmelden',
  nav_login: 'Anmelden',
  nav_signup: 'Registrieren',

  // Dashboard
  dashboard_welcome: 'Willkommen zurück',
  dashboard_total_earnings: 'Gesamteinnahmen',
  dashboard_pending_orders: 'Ausstehende Bestellungen',
  dashboard_completed_orders: 'Abgeschlossene Bestellungen',
  dashboard_commission_rate: 'Provisionssatz',
  dashboard_quick_actions: 'Schnellaktionen',
  dashboard_recent_orders: 'Letzte Bestellungen',
  dashboard_recent_activity: 'Letzte Aktivität',
  dashboard_wallet_balance: 'Geldbörsen-Guthaben',
  dashboard_deposit: 'Einzahlen',
  dashboard_withdraw: 'Abheben',
  dashboard_view_all: 'Alle Anzeigen',

  // Orders
  orders_title: 'Meine Bestellungen',
  orders_all: 'Alle Bestellungen',
  orders_pending: 'Ausstehend',
  orders_completed: 'Abgeschlossen',
  orders_cancelled: 'Storniert',
  orders_order_id: 'Bestellnummer',
  orders_platform: 'Plattform',
  orders_amount: 'Betrag',
  orders_commission: 'Provision',
  orders_status: 'Status',
  orders_date: 'Datum',
  orders_no_orders: 'Keine Bestellungen gefunden',

  // Wallet
  wallet_title: 'Meine Geldbörse',
  wallet_available_balance: 'Verfügbares Guthaben',
  wallet_pending_balance: 'Ausstehendes Guthaben',
  wallet_total_withdrawn: 'Gesamt Abgehoben',
  wallet_deposit_now: 'Jetzt Einzahlen',
  wallet_withdraw_now: 'Jetzt Abheben',
  wallet_transaction_history: 'Transaktionsverlauf',
  wallet_deposit_history: 'Einzahlungsverlauf',
  wallet_withdrawal_history: 'Abhebungsverlauf',
  wallet_deposit_desc: "Fügen Sie Geld zu Ihrer Wallet mit verfügbaren Zahlungsmethoden hinzu.",
  wallet_no_deposits: "Keine Einzahlungen gefunden.",
  wallet_withdraw_history: "Auszahlungsverlauf",
  wallet_withdraw_desc: "Geld aus Ihrer Wallet abheben.",
  wallet_no_withdrawals: "Keine Auszahlungen gefunden.",
  wallet_no_withdrawals_desc: "Sie haben noch keine Auszahlungen vorgenommen.",
  // Analytics
  analytics_title: 'Analytik',
  analytics_earnings_overview: 'Einnahmenübersicht',
  analytics_platform_breakdown: 'Plattform-Aufschlüsselung',
  analytics_performance_metrics: 'Leistungsmetriken',
  analytics_top_products: 'Top-Produkte',
  analytics_this_month: 'Dieser Monat',
  analytics_last_month: 'Letzter Monat',
  analytics_total_revenue: 'Gesamtumsatz',
  analytics_avg_order_value: 'Durchschn. Bestellwert',

  // Referral
  referral_title: 'Empfehlungsprogramm',
  referral_your_code: 'Ihr Empfehlungscode',
  referral_copy_code: 'Code Kopieren',
  referral_share_link: 'Link Teilen',
  referral_total_referrals: 'Gesamte Empfehlungen',
  referral_active_referrals: 'Aktive Empfehlungen',
  referral_referral_earnings: 'Empfehlungseinnahmen',
  referral_invite_friends: 'Freunde Einladen',

  // Account
  account_title: 'Kontoeinstellungen',
  account_profile: 'Profil',
  account_security: 'Sicherheit',
  account_notifications: 'Benachrichtigungen',
  account_kyc: 'KYC-Verifizierung',
  account_phone: 'Telefonnummer',
  account_two_factor: 'Zwei-Faktor-Authentifizierung',
  account_save_changes: 'Änderungen Speichern',
  account_cancel: 'Abbrechen',

  // Support
  support_title: 'Support-Center',
  support_faq: 'Häufig Gestellte Fragen',
  support_contact_us: 'Kontaktieren Sie Uns',
  support_live_chat: 'Live-Chat',
  support_ticket_tracker: 'Ticket-Tracker',
  support_submit_ticket: 'Ticket Einreichen',

  // Auth
  auth_email: 'E-Mail',
  auth_password: 'Passwort',
  auth_confirm_password: 'Passwort Bestätigen',
  auth_forgot_password: 'Passwort Vergessen?',
  auth_remember_me: 'Angemeldet Bleiben',
  auth_login_button: 'Anmelden',
  auth_signup_button: 'Registrieren',
  auth_already_have_account: 'Haben Sie bereits ein Konto?',
  auth_dont_have_account: 'Haben Sie kein Konto?',
  auth_reset_password: 'Passwort Zurücksetzen',
  auth_verify_email: 'E-Mail Verifizieren',

  // Common
  common_loading: 'Laden...',
  common_save: 'Speichern',
  common_cancel: 'Abbrechen',
  common_delete: 'Löschen',
  common_edit: 'Bearbeiten',
  common_view: 'Ansehen',
  common_search: 'Suchen',
  common_filter: 'Filtern',
  common_export: 'Exportieren',
  common_import: 'Importieren',
  common_submit: 'Absenden',
  common_close: 'Schließen',
  common_confirm: 'Bestätigen',
  common_success: 'Erfolg',
  common_error: 'Fehler',
  common_warning: 'Warnung',

  // Homepage
  home_hero_title: 'Verdienen Sie Provisionen von Top-E-Commerce-Plattformen',
  home_hero_subtitle: 'Schließen Sie sich Tausenden von Nutzern an, die täglich Provisionen von Walmart, Alibaba und AliExpress verdienen',
  home_get_started: 'Jetzt Starten',
  home_learn_more: 'Mehr Erfahren',
  home_how_it_works: 'Wie Es Funktioniert',
  home_features: 'Funktionen',
  home_commission_tiers: 'Provisionsstufen',
  home_testimonials: 'Was Unsere Nutzer Sagen',
  home_faq: 'Häufig Gestellte Fragen',
  home_cta_title: 'Bereit, Mit Dem Verdienen Zu Beginnen?',
  home_cta_subtitle: 'Treten Sie unserer Community bei und beginnen Sie, Provisionen zu verdienen',
  feature_6_title: '24/7 Support',
  feature_6_desc: 'Unser engagiertes Support-Team ist immer bereit zu helfen. Erhalten Sie Unterstützung über Live-Chat, E-Mail oder Telefon.',
  feature_6_detail_1: 'Live-Chat verfügbar',
  feature_6_detail_2: 'E-Mail-Support rund um die Uhr',
  feature_6_detail_3: 'Telefonische Unterstützung',
  feature_6_detail_4: 'Umfassendes FAQ',
  feature_7_title: 'Empfehlungsprogramm',
  feature_7_desc: 'Verdienen Sie zusätzliches Einkommen, indem Sie Freunde einladen. Erhalten Sie lebenslange Provisionen von den Einnahmen Ihrer Empfehlungen.',
  feature_7_detail_1: 'Lebenslange Empfehlungseinnahmen',
  feature_7_detail_2: 'Unbegrenzte Empfehlungen',
  feature_7_detail_3: 'Einfache Sharing-Tools',
  feature_7_detail_4: 'Bonus-Anreize',
  feature_8_title: 'Multiwährung',
  feature_8_desc: 'Unterstützung für die wichtigsten Währungen und Zahlungsmethoden. Wählen Sie aus, was für Sie am besten funktioniert.',
  feature_8_detail_1: 'USD, EUR, GBP Unterstützung',
  feature_8_detail_2: 'Banküberweisung verfügbar',
  feature_8_detail_3: 'E-Wallet-Integration',
  feature_8_detail_4: 'Kryptowährungsoptionen in Kürze',
  feature_9_title: 'Sofortige Benachrichtigungen',
  feature_9_desc: 'Bleiben Sie mit Echtzeit-Benachrichtigungen über neue Bestellungen, Einnahmen und Kontoaktivitäten auf dem Laufenden.',
  feature_9_detail_1: 'Push-Benachrichtigungen',
  feature_9_detail_2: 'E-Mail-Benachrichtigungen',
  feature_9_detail_3: 'SMS-Updates',
  feature_9_detail_4: 'In-App-Nachrichten',

  // Footer
  footer_about: 'Über Uns',
  footer_terms: 'Nutzungsbedingungen',
  footer_privacy: 'Datenschutzrichtlinie',
  footer_contact: 'Kontakt',
  footer_copyright: 'Alle Rechte vorbehalten',

  // Redesigned Footer
  footer_stay_loop_title: 'Bleiben Sie auf dem Laufenden',
  footer_stay_loop_desc: 'Erhalten Sie die neuesten Updates, Tipps und exklusiven Angebote direkt in Ihren Posteingang.',
  footer_subscribe: 'Abonnieren',
  footer_subscribe_placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
  footer_trusted_secure: 'VERTRAUENSWÜRDIG & SICHER:',
  footer_ssl_secured: 'SSL-gesichert',
  footer_ssl_secured_desc: '256-Bit SSL',
  footer_aes_encryption: 'AES-256 Verschlüsselung',
  footer_aes_encryption_desc: 'Bankenniveau',
  footer_kyc_compliant: 'KYC-konform',
  footer_kyc_compliant_desc: 'Verifiziert',
  footer_gdpr_compliant: 'DSGVO-konform',
  footer_gdpr_compliant_desc: 'Datenschutz garantiert',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Zertifiziert',
  footer_platform: 'PLATTFORM',
  footer_support: 'SUPPORT',
  footer_legal: 'RECHTLICHES',
  footer_help_center: 'Hilfe-Center',
  footer_contact_us: 'Kontaktieren Sie uns',
  footer_payments_label: 'Zahlungen:',
  home_live_activity_title: 'Live-Plattform-Aktivität',
  home_recent_activity_title: 'Kürzliche Aktivitäten',
  home_total_commissions_paid: 'Gezahlte Gesamtomissionen',
  home_active_users_online: 'Aktive Benutzer online',
  home_tasks_completed_today: 'Heute abgeschlossene Aufgaben',
  account_security_tips_title: 'Sicherheitsempfehlungen',
  account_security_tips_desc: 'Verbessern Sie Ihren Kontoschutz, indem Sie diese einfachen Best Practices befolgen.',
  tip_password_title: 'Starkes Passwort',
  tip_password_desc: 'Verwenden Sie eine Kombination aus Buchstaben, Zahlen und Symbolen, um die Sicherheit Ihres Kontos zu gewährleisten.',
  tip_two_factor_title: 'Identitätsprüfung',
  tip_two_factor_desc: 'Halten Sie Ihre Kontaktinformationen auf dem neuesten Stand, um wichtige Sicherheitsbenachrichtigungen zu erhalten.',
  tip_logout_title: 'Regelmäßige Abmeldung',
  tip_logout_desc: 'Melden Sie sich immer von Ihrem Konto ab, wenn Sie öffentliche oder gemeinsam genutzte Computer verwenden.',
  tip_sharing_title: 'Zugriff nie teilen',
  tip_sharing_desc: 'Unser Support-Team wird Sie niemals nach Ihrem Passwort fragen. Teilen Sie Ihre Anmeldedaten niemals mit anderen.',
};